module.exports = __webpack_public_path__ + "static/media/unfi_doodle_multi.4652aa63.png";